(function () {
    "use strict";

    angular.module("trakeyeApp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider
            .state("work-flow-type", {
                parent: "entity",
                url: "/work-flow-type",
                data: {
                    authorities: ["ROLE_USER_ADMIN","ROLE_PLAN_ADMIN","ROLE_ROLLOUT_ADMIN"],
                    pageTitle: "trakeyeApp.workflowType.home.title",
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/work-flow-type/work-flow-types.html",
                        controller: "WorkFlowTypeController",
                        controllerAs: "vm",
                    },
                },
                params: {
                    page: {
                        value: "1",
                        squash: true,
                    },
                    sort: {
                        value: "update_date,desc",
                        squash: true,
                    },
                    search: null,
                },
                resolve: {
                    pagingParams: [
                        "$stateParams",
                        "PaginationUtil",
                        function ($stateParams, PaginationUtil) {
                            return {
                                page: PaginationUtil.parsePage(
                                    $stateParams.page
                                ),
                                sort: $stateParams.sort,
                                predicate: PaginationUtil.parsePredicate(
                                    $stateParams.sort
                                ),
                                ascending: PaginationUtil.parseAscending(
                                    $stateParams.sort
                                ),
                                search: $stateParams.search,
                            };
                        },
                    ],
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("workFlowType");
                            $translatePartialLoader.addPart("global");
                            return $translate.refresh();
                        },
                    ],
                },
            })
            .state("work-flow-type-detail", {
                parent: "work-flow-type",
                url: "/work-flow-type/{id}",
                data: {
                    authorities: ["ROLE_USER_ADMIN","ROLE_PLAN_ADMIN","ROLE_ROLLOUT_ADMIN"],
                    pageTitle: "trakeyeApp.workflowType.detail.title",
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/work-flow-type/work-flow-type-detail.html",
                        controller: "WorkFlowTypeDetailController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("workFlowType");
                            return $translate.refresh();
                        },
                    ],
                    entity: [
                        "$stateParams",
                        "WorkFlowType",
                        function ($stateParams, WorkFlowType) {
                            return WorkFlowType.get({ id: $stateParams.id })
                                .$promise;
                        },
                    ],
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name: $state.current.name || "work-flow-type",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                ),
                            };
                            return currentStateData;
                        },
                    ],
                },
            })

            .state("work-flow-type.new", {
                parent: "work-flow-type",
                url: "/create",
                data: {
                    authorities: ["ROLE_USER_ADMIN","ROLE_PLAN_ADMIN","ROLE_ROLLOUT_ADMIN"],
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/work-flow-type/work-flow-type-dialog.html",
                        controller: "WorkFlowTypeDialogController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    entity: function () {
                        return {
                            name: null,
                            description: null,
                            createdDate: null,
                            updateDate: null,
                            id: null,
                        };
                    },
                },
            })
            .state("work-flow-type.edit", {
                parent: "work-flow-type",
                url: "/{id}/edit",
                data: {
                    authorities: ["ROLE_USER_ADMIN","ROLE_PLAN_ADMIN","ROLE_ROLLOUT_ADMIN"],
                    pageTitle: "trakeyeApp.workflowType.detail.title",
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/work-flow-type/work-flow-type-dialog.html",
                        controller: "WorkFlowTypeDialogController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("workFlowType");
                            return $translate.refresh();
                        },
                    ],
                    entity: [
                        "$stateParams",
                        "WorkFlowType",
                        function ($stateParams, WorkFlowType) {
                            return WorkFlowType.get({ id: $stateParams.id })
                                .$promise;
                        },
                    ],
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name: $state.current.name || "work-flow-type",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                ),
                            };
                            return currentStateData;
                        },
                    ],
                },
            })

            .state("work-flow-type.delete", {
                parent: "work-flow-type",
                url: "/{id}/delete",
                data: {
                    authorities: ["ROLE_USER_ADMIN","ROLE_PLAN_ADMIN","ROLE_ROLLOUT_ADMIN"],
                },
                onEnter: [
                    "$stateParams",
                    "$state",
                    "$uibModal",
                    function ($stateParams, $state, $uibModal) {
                        $uibModal
                            .open({
                                templateUrl:
                                    "app/entities/work-flow-type/work-flow-type-delete-dialog.html",
                                controller: "WorkFlowTypeDeleteController",
                                controllerAs: "vm",
                                size: "sm",
                                resolve: {
                                    entity: [
                                        "WorkFlowType",
                                        function (WorkFlowType) {
                                            return WorkFlowType.get({
                                                id: $stateParams.id,
                                            }).$promise;
                                        },
                                    ],
                                },
                            })
                            .result.then(
                                function () {
                                    $state.go("work-flow-type", null, {
                                        reload: "work-flow-type",
                                    });
                                },
                                function () {
                                    $state.go("^");
                                }
                            );
                    },
                ],
            });
    }
})();
